/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/button-has-type */
import React,{useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import swal from 'sweetalert';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import calendarIcon from '../../atoms/customIcons/calendarIcon.svg';
import IconCustom from '../iconCustom/iconCustom';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import ModalBootstrap from 'react-bootstrap/Modal';
import { ButtonTheme } from '../button/button';
import './divider.scss';
export default function Divider({ text }) {
  return (
       <div className="divider">
      <hr />
      {text && <span>{text}</span>}
    </div>
  );
}